export function accountRequestGate() {
  let activeAccount: string | null = null;
  let generation = 0;
  const open = (accountId: string) => {
    activeAccount = accountId;
    const issued = ++generation;
    return () => activeAccount === accountId && generation === issued;
  };
  return {
    open,
    refresh: (accountId: string) =>
      activeAccount === accountId ? open(accountId) : null,
    invalidate: () => {
      activeAccount = null;
      generation++;
    },
  };
}
